type Params = {
  mediaFilters:
    | {
        id?: number;
        name: string;
        url: string;
      }[]
    | null
    | undefined;
  filterName: string | string[];
};

export default function getMediaFilterUrl({
  mediaFilters,
  filterName,
}: Params) {
  if (mediaFilters) {
    const names = Array.isArray(filterName) ? filterName : [filterName];
    for (const name of names) {
      const filter = mediaFilters.find(({ name: n }) => n === name);
      if (filter) return filter.url;
    }
  }
}
